import { useEffect, useState } from 'react'
import styles from './PurchaseBusinessPage.module.css'
import { useBusiness } from '../BusinessCardPage/BusinessContext'
import { useNavigate } from 'react-router-dom'
import { BUSINESS_PAGE, MAIN_PAGE } from '../../router/paths'
import InternalHeader from '../../components/InternalHeader/InternalHeader'
import PurchaseBusinessPageStageOne from './PurchaseBusinessPageStages/PurchaseBusinessPageStageOne/PurchaseBusinessPageStageOne'
import PurchaseBusinessPageStageTwo from './PurchaseBusinessPageStages/PurchaseBusinessPageStageTwo/PurchaseBusinessPageStageTwo'
import PurchaseBusinessPageStageThree from './PurchaseBusinessPageStages/PurchaseBusinessPageStageThree/PurchaseBusinessPageStageThree'

export default function PurchaseBusinessPage() {
  const navigate = useNavigate()
  const { business, selectedOption } = useBusiness()
  const [currentStage, setCurrentStage] = useState(0);

  useEffect(() => {
    if (!business) {
      navigate(MAIN_PAGE)
    }
  }, [business, navigate])

  const stages = ['1', '2', '3'];

  const handleNextStage = () => {
    if (currentStage < stages.length - 1) {
      setCurrentStage(currentStage + 1);
    }
  };

  if (!business) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <InternalHeader 
        title='Бронирование' 
        onClose={() => navigate(BUSINESS_PAGE.replace(':id', business.id.toString()))} 
      />
      
      <div className={styles.content_wrapper}>
        <div className={styles.content}>
          {currentStage === 0 && (
              <PurchaseBusinessPageStageOne
                  selectedOption={selectedOption}
                  business={business}
                  handleNextStage={handleNextStage}
              />
          )}
          {currentStage === 1 && (
              <PurchaseBusinessPageStageTwo
                  handleNextStage={handleNextStage}
              />
          )}
          {currentStage === 2 && (
              <PurchaseBusinessPageStageThree />
          )}
        </div>
      </div>
    </div>
  )
}
